import React, { FC } from "react";
import { Flex } from "../../atoms/flex";
import { Icon, IconType } from "../../atoms/icon";
import { Title } from "../../atoms/title";
import "./savings-print.css";

interface SavingsCardProps {
  icon?: IconType;
  text?: string;
  bullets?: Array<string>;
  className?: string;
}

/**
 * Savings card component
 */
export const SavingsPrint: FC<SavingsCardProps> = ({
  icon,
  text,
  bullets,
  className,
}) => {
  return (
    <Flex className={`SavingsPrint ${className || ""}`}>
      <Icon type={icon} size="xl" />
      <Title text={text} className="title" tag="h3" />
      <ul>
        {bullets?.map((bullet, index) => (
          <li key={index.toString()}>
            <Title tag="h4" text={bullet || ""} />
          </li>
        ))}
      </ul>
    </Flex>
  );
};
